<template>
  <div
    class="c-app"
    :class="{ 'c-dark-theme': $store.state.darkMode }"
    :style="$store.state.asideShow ? 'padding-right: 320px' : ''"
  >
    <c-toaster
      v-for="(toaster, toasterKey) in errorMessages"
      :key="'toaster-error-' + toasterKey"
      position="top-center"
    >
      <template v-for="(toast, key) in toaster">
        <c-toast :key="'toast-error' + key" :show="true" v-bind="toast" class="toast-error">
          <div v-html="toast.message" />
        </c-toast>
      </template>
    </c-toaster>
    <c-toaster
      v-for="(toaster, toasterKey) in successMessages"
      :key="'toaster-success' + toasterKey"
      position="top-right"
    >
      <template v-for="(toast, key) in toaster">
        <c-toast :key="'toast-success' + key" :show="true" v-bind="toast" class="toast-success">
          <div v-html="toast.message" />
        </c-toast>
      </template>
    </c-toaster>
    <the-sidebar />
    <the-aside />
    <c-wrapper>
      <the-header />
      <div class="c-body">
        <main class="c-main">
          <c-container fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </c-container>
        </main>
        <the-footer />
      </div>
    </c-wrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar';
import TheHeader from './TheHeader';
import TheFooter from './TheFooter';
import TheAside from './TheAside';

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside,
  },
  computed: {
    errorMessages() {
      return this.$store.state.messages.errors.reduce((toasters, toast) => {
        toasters[toast.position] = toasters[toast.position] || [];
        toasters[toast.position].push(toast);
        return toasters;
      }, {});
    },
    successMessages() {
      return this.$store.state.messages.success.reduce((toasters, toast) => {
        toasters[toast.position] = toasters[toast.position] || [];
        toasters[toast.position].push(toast);
        return toasters;
      }, {});
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style>
.c-dark-theme a {
  color: #5eceb3;
}
.bg-kb-primary {
  background-color: #5eceb3 !important;
}
.popover-body {
  width: 250px;
}

.toast-error .toast-body {
  background: #f6e1e1 !important;
  border-color: #f2d4d4;
  color: #6d3540;
}
.toast-error .toast-header {
  background: #f6e1e1 !important;
  color: #6d3540;
}
.toast-error .close {
  color: #6d3540;
  text-shadow: none;
}

.toast-success .toast-body {
  background: #daece0 !important;
  border-color: #cbe5d4;
  color: #24543e;
}
.toast-success .toast-header {
  background: #daece0 !important;
  color: #24543e;
}
.toast-success .close {
  color: #24543e;
  text-shadow: none;
}

.c-sidebar .tab-content {
  height: 100vh;
  overflow: auto;
}
</style>
